<template>
  <Teleport to=".js-gallery-zoom-pane">
    <div class="ProductGallery__ZoomPane" v-if="media">
      <div class="">
        <button role="button" @click="emits('updateModal', false)">
          <Icon :icon="'close'" />
        </button>
        <picture>
          <source media="(min-width:320px)" :srcset="media.image.url" />
          <img lazy="eager" :src="media.image.url" :alt="media.alt" />
        </picture>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import Icon from '../Global/Icon.vue';

import { watch } from 'vue';

const emits = defineEmits(['updateModal']);
const props = defineProps({
  media: {
    required: true,
    default: false,
    type: [Boolean, Object],
  },
});

watch(
  () => props.media,
  (hasMedia) => {
    ugcVideo('hide');
    const template = document.querySelector('body');
    if (hasMedia) template.classList.add('no-scroll');
    else template.classList.remove('no-scroll');
  }
);
</script>
